import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Alert } from '@zillow/constellation';
import {
  getAreCriminalReportsInDisputeSelector,
  getAreEvictionReportsInDisputeSelector,
} from '../../../../../../../selectors/sharedReports';

export const DISPUTE_TEXT = `can't be pulled at this time. The report should automatically refresh with the complete information within 1 business day.`;

function BackgroundCheckDisputeAlert({ applicant }) {
  const { userId: applicantId } = applicant;
  const areCriminalReportsInDispute = useSelector(getAreCriminalReportsInDisputeSelector(applicantId));
  const areEvictionReportsInDispute = useSelector(getAreEvictionReportsInDisputeSelector(applicantId));

  let body = null;

  // Both sections are in dispute.
  if (areCriminalReportsInDispute && areEvictionReportsInDispute) {
    body = `Background report ${DISPUTE_TEXT}`;
    // Only one section is in dispute.
  } else if (areCriminalReportsInDispute || areEvictionReportsInDispute) {
    const recordName = areCriminalReportsInDispute ? 'Criminal' : 'Housing court';
    body = `${recordName} report ${DISPUTE_TEXT}`;
  }

  return body && <Alert appearance="warning" body={body} />;
}

BackgroundCheckDisputeAlert.propTypes = {
  applicant: PropTypes.shape({
    userId: PropTypes.string.isRequired,
  }).isRequired,
};

export default BackgroundCheckDisputeAlert;
